export const FONT_PRELOADS: ReadonlyArray<string> = [
    'assets/fonts/outfit/Outfit-VariableFont.woff2',
];
